import React from "react";
import TableLoaderEffect from "../../../constant/TableLoader";
import { useNavigate } from "react-router-dom";
import { viewPDFFile } from "..";
const maxWidthStyle300 = {
  maxWidth: "30rem",
  minWidth: "10rem",
  whiteSpace: "normal",
  display: "block",
};

const CommonStandardPage = ({ data, isLoading, type, userRole }) => {
  const navigate = useNavigate();

  return (
    <>
      <div>
        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
          <div
            id="employee-tbl_wrapper"
            className="dataTables_wrapper no-footer"
          >
            <table
              id="empoloyees-tblwrapper"
              className="table ItemsCheckboxSec dataTable no-footer mb-0  table-striped"
            >
              <thead>
                <tr>
                  <th>{type} Number</th>
                  <th>Part Number</th>
                  <th>Section Number</th>
                  <th>Document Year</th>
                  {userRole !== "User" && <th>Status</th>}
                  <th>Description</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <TableLoaderEffect colLength={userRole === "User" ? 6 : 7} />
                ) : (
                  data.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <span
                          onClick={() => navigate(`/standards/${item.id}`)}
                          className="text-primary cursor-pointer fw-bolder"
                        >
                          {item.standard_no}
                        </span>
                      </td>
                      <td>{item.part_no}</td>
                      <td>{item.section_no}</td>
                      <td>{item.document_year}</td>
                      {userRole !== "User" &&
                        <td>
                          {item.is_approved ? (
                            <span className={`badge light border-0 badge-success badge-sm`}>APPROVED</span>
                          ) : (
                            <span className={`badge light border-0 badge-info badge-sm`}>PENDING</span>
                          )}
                        </td>
                      }
                      <td>
                        <span style={maxWidthStyle300}>

                          {item.description}
                        </span>
                      </td>
                      <td>
                        {item.is_file ?
                          <button className="btn btn-outline-primary btn-sm mb-3 mb-md-0"
                            onClick={() => viewPDFFile(item.id)}
                          ><span><i className="fa-solid fa-eye me-2" /> View</span>
                          </button> : "File NP"
                        }
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonStandardPage;
